import conditionHelper from "../../helpers/condition";
export default {
  computed: {
    showDiscussion() {
      const conditions = JSON.parse(localStorage.getItem("conditions"));
      return (
        conditions &&
        (conditions.rcfchatclientagency || conditions.rcfchatadvteamclient)
      );
    },
    showAdvTeamDiscussion() {
      return conditionHelper("rcfchatadvteamclient");
    },
    showAgencyDiscussion() {
      return conditionHelper("rcfchatclientagency");
    }
  }
};
